import "core-js/modules/es6.reflect.construct.js";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "element", "ref", "getScrollParent", "treeList", "handleTreeListChange", "store"];
import "core-js/modules/es6.array.slice.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * 处理滚动加载逻辑
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { debounce, throttle } from './util';
import CONFIG from './config';
import omit from "omit.js";

var InfiniteScroll = /*#__PURE__*/function (_Component) {
  _inherits(InfiniteScroll, _Component);

  var _super = _createSuper(InfiniteScroll);

  function InfiniteScroll(props) {
    var _this;

    _classCallCheck(this, InfiniteScroll);

    _this = _super.call(this, props); //默认显示20条，rowsInView根据定高算的。在非固定高下，这个只是一个大概的值。

    _defineProperty(_assertThisInitialized(_this), "eventListenerOptions", function () {
      var options = _this.props.useCapture;

      if (_this.isPassiveSupported()) {
        options = {
          useCapture: _this.props.useCapture,
          passive: true
        };
      }

      return options;
    });

    _defineProperty(_assertThisInitialized(_this), "mousewheelListener", function (e) {
      // Prevents Chrome hangups
      // See: https://stackoverflow.com/questions/47524205/random-high-content-download-time-in-chrome/47684257#47684257
      if (e.deltaY === 1 && !_this.isPassiveSupported()) {
        e.preventDefault();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "scrollListener", function () {
      var el = _this.scrollComponent;

      var parentNode = _this.getParentElement(el);

      _this.scrollTop = parentNode.scrollTop;

      _this.handleScrollY();
    });

    _defineProperty(_assertThisInitialized(_this), "handleScrollY", function (isNewDataLess, isFold) {
      var store = _this.props.store;

      var parentElement = _this.getParentElement(_this.scrollComponent);

      if (!parentElement) {
        return;
      }

      var scrollEl = parentElement;
      var scrollY = scrollEl && scrollEl.clientHeight;
      var rowHeight = store.getState().rowHeight; //默认显示20条，rowsInView根据定高算的。在非固定高下，这个只是一个大概的值。

      _this.rowsInView = scrollY ? Math.floor(scrollY / rowHeight) : CONFIG.defaultRowsInView;
      var currentIndex = _this.currentIndex,
          startIndex = _this.startIndex,
          endIndex = _this.endIndex,
          treeList = _this.treeList,
          loadCount = _this.loadCount,
          rowsInView = _this.rowsInView;
      var index = 0;
      var tempScrollTop = _this.scrollTop; //根据 scrollTop 计算 currentIndex

      while (tempScrollTop > 0) {
        tempScrollTop -= rowHeight;

        if (tempScrollTop > 0) {
          index += 1;
        }
      }

      if (isNewDataLess && !isFold) {
        parentElement.scrollTop = 0; // 如果不是因为点击收起造成的数据减少，则滚动条回到顶部
      } //true 为向下滚动， false 为向上滚动


      var isScrollDown = index - currentIndex > 0 ? true : false;
      if (index < 0) index = 0; //如果之前的索引和下一次的不一样则重置索引和滚动的位置

      _this.currentIndex = currentIndex !== index ? index : currentIndex; // 如果rowsInView 小于 缓存的数据则重新render
      // 向下滚动 下临界值超出缓存的endIndex则重新渲染

      if (isScrollDown && rowsInView + index > endIndex - CONFIG.rowDiff) {
        startIndex = index - CONFIG.loadBuffer > 0 ? index - CONFIG.loadBuffer : 0;
        endIndex = startIndex + loadCount;

        if (endIndex > treeList.length) {
          endIndex = treeList.length;
        }

        if (endIndex > _this.endIndex) {
          _this.startIndex = startIndex;
          _this.endIndex = endIndex;

          _this.sliceTreeList(_this.startIndex, _this.endIndex);
        }
      } // 向上滚动，当前的index是否已经加载（currentIndex），若干上临界值小于startIndex则重新渲染


      if (!isScrollDown && index < startIndex + CONFIG.rowDiff) {
        startIndex = index - CONFIG.loadBuffer;

        if (startIndex < 0) {
          startIndex = 0;
        }

        if (startIndex <= _this.startIndex) {
          _this.startIndex = startIndex;
          _this.endIndex = _this.startIndex + loadCount;

          _this.sliceTreeList(_this.startIndex, _this.endIndex);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "sliceTreeList", function (startIndex, endIndex) {
      var newTreeList = []; //存储截取后的新数据

      newTreeList = _this.treeList.slice(startIndex, endIndex);
      _this.props.handleTreeListChange && _this.props.handleTreeListChange(newTreeList, startIndex, endIndex);
    });

    _this.rowsInView = CONFIG.defaultRowsInView; //一维数组

    _this.treeList = props.treeList; //一次加载多少数据

    _this.loadCount = CONFIG.loadBuffer ? _this.rowsInView + CONFIG.loadBuffer * 2 : 16; //可视区第一条数据的 index

    _this.currentIndex = 0;
    _this.startIndex = _this.currentIndex; //数据开始位置

    _this.endIndex = _this.currentIndex + _this.loadCount; //数据结束位置

    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.options = this.eventListenerOptions();
      this.attachScrollListener();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var newTreeList = nextProps.treeList;
      var oldTreeList = this.props.treeList;

      if (newTreeList !== oldTreeList) {
        var isNewDataLess = newTreeList.length < oldTreeList.length;
        this.treeList = newTreeList;
        this.handleScrollY(isNewDataLess, nextProps.isFold);
      }
    } // componentDidUpdate() {
    //   const el = this.scrollComponent;
    //   const parentNode = this.getParentElement(el);
    //   parentNode.scrollTop = this.scrollTop;
    // };

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.detachScrollListener();
      this.detachMousewheelListener();
    }
  }, {
    key: "isPassiveSupported",
    value: function isPassiveSupported() {
      var passive = false;
      var testOptions = {
        get passive() {
          passive = true;
        }

      };

      try {
        document.addEventListener('test', null, testOptions);
        document.removeEventListener('test', null, testOptions);
      } catch (e) {// ignore
      }

      return passive;
    }
  }, {
    key: "detachMousewheelListener",
    value:
    /**
     * 解除mousewheel事件监听
     */
    function detachMousewheelListener() {
      var scrollEl = window;

      if (this.props.useWindow === false) {
        scrollEl = this.scrollComponent.parentNode;
      }

      scrollEl.removeEventListener('mousewheel', this.mousewheelListener, this.options ? this.options : this.props.useCapture);
    }
    /**
     * 解除scroll事件监听
     */

  }, {
    key: "detachScrollListener",
    value: function detachScrollListener() {
      var scrollEl = window;

      if (this.props.useWindow === false) {
        scrollEl = this.getParentElement(this.scrollComponent);
      }

      scrollEl.removeEventListener('scroll', this.scrollListener, this.options ? this.options : this.props.useCapture);
      scrollEl.removeEventListener('resize', this.scrollListener, this.options ? this.options : this.props.useCapture);
    }
    /**
     * 获取父组件(用户自定义父组件或者当前dom的parentNode)
     * @param {*} el 
     */

  }, {
    key: "getParentElement",
    value: function getParentElement(el) {
      var scrollParent = this.props.getScrollParent && this.props.getScrollParent();

      if (scrollParent != null) {
        return scrollParent;
      }

      return el && el.parentNode;
    }
  }, {
    key: "filterProps",
    value: function filterProps(props) {
      return props;
    }
    /**
     * 绑定scroll事件
     */

  }, {
    key: "attachScrollListener",
    value: function attachScrollListener() {
      var _this$props = this.props,
          store = _this$props.store,
          debounceDuration = _this$props.debounceDuration;
      var parentElement = this.getParentElement(this.scrollComponent);

      if (!parentElement) {
        return;
      }

      var scrollEl = parentElement;
      var scrollY = scrollEl && scrollEl.clientHeight;
      var rowHeight = store.getState().rowHeight; //默认显示20条，rowsInView根据定高算的。

      this.rowsInView = scrollY ? Math.floor(scrollY / rowHeight) : CONFIG.defaultRowsInView;
      scrollEl.addEventListener('scroll', throttle(this.scrollListener, debounceDuration || 150), this.options ? this.options : this.props.useCapture);
      scrollEl.addEventListener('resize', throttle(this.scrollListener, debounceDuration || 150), this.options ? this.options : this.props.useCapture);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          element = _this$props2.element,
          ref = _this$props2.ref,
          getScrollParent = _this$props2.getScrollParent,
          treeList = _this$props2.treeList,
          handleTreeListChange = _this$props2.handleTreeListChange,
          store = _this$props2.store,
          props = _objectWithoutProperties(_this$props2, _excluded);

      props.ref = function (node) {
        _this2.scrollComponent = node;

        if (ref) {
          ref(node);
        }
      };

      var childrenArray = [children];
      return /*#__PURE__*/React.createElement(element, omit(props, ["debounceDuration", "isFold"]), childrenArray);
    }
  }]);

  return InfiniteScroll;
}(Component);

_defineProperty(InfiniteScroll, "propTypes", {
  children: PropTypes.node.isRequired,
  element: PropTypes.node,
  ref: PropTypes.func,
  getScrollParent: PropTypes.func,
  treeList: PropTypes.array,
  handleTreeListChange: PropTypes.func
});

_defineProperty(InfiniteScroll, "defaultProps", {
  element: 'div',
  ref: null,
  getScrollParent: null,
  treeList: [],
  handleTreeListChange: function handleTreeListChange() {}
});

export { InfiniteScroll as default };


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-tree/src/infiniteScroll.js